"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// ... console.logs are not removed (commented) to enable easier debugging/implementing new redirecting if needed in future
var actions = {
    "wizard/goForward": function (_a, vm) {
        var getters = _a.getters, commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var activeCabinKey, next, currentStep;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        activeCabinKey = getters["management/activeCabinKey"];
                        next = getters["wizard/nextJumpInfo"](vm);
                        if (!next.changingCabin) return [3 /*break*/, 3];
                        currentStep = getters["currentCabin/wizard/currentStep"];
                        if (currentStep) {
                            // console.log("committing completion of", currentStep.name)
                            commit("currentCabin/wizard/setStepCompleted", currentStep.name);
                        }
                        else {
                            // console.log("woot no curr step")
                        }
                        // console.log("activating", next.cabin)
                        return [4 /*yield*/, dispatch("management/setActiveCabin", next.cabin)];
                    case 1:
                        // console.log("activating", next.cabin)
                        _b.sent();
                        return [4 /*yield*/, dispatch("wizard/jumpMax", vm)];
                    case 2: return [2 /*return*/, _b.sent()];
                    case 3:
                        if (!(next.route === "bookingCheckout")) return [3 /*break*/, 4];
                        // console.log("should be handled by bea frontend? dunno... i do have the router here... could do that")
                        commit("currentCabin/wizard/setStepCompleted", "bookingInsurance");
                        vm.$router.push({ name: "bookingCheckout", params: vm.$route.params });
                        return [2 /*return*/];
                    case 4: return [4 /*yield*/, dispatch(activeCabinKey + "/wizard/goForward", vm)];
                    case 5: 
                    // console.log("normal go forward")
                    return [2 /*return*/, _b.sent()];
                }
            });
        });
    },
    "wizard/jumpMax": function (_a, vm) {
        var getters = _a.getters;
        return __awaiter(this, void 0, void 0, function () {
            var firstStepName, target;
            return __generator(this, function (_b) {
                if (getters["wizard/allCompleted"]) {
                    return [2 /*return*/];
                }
                firstStepName = "bookingPersons";
                target = getters["currentCabin/wizard/step"](firstStepName);
                while (getters["currentCabin/wizard/next"](target.name) &&
                    getters["currentCabin/wizard/canJumpToStep"](getters["currentCabin/wizard/next"](target.name).name, firstStepName)) {
                    target = getters["currentCabin/wizard/next"](target.name);
                }
                vm.$router.push({ name: target.name, params: vm.$route.params });
                return [2 /*return*/];
            });
        });
    },
};
var getters = {
    "wizard/nextJumpInfo": function (_state, getters) {
        return function (vm) {
            // everything done so checkout
            if (getters["currentCabin/wizard/allValid"] &&
                !getters["wizard/firstIncompleted"]) {
                // console.log("jumpinfo triggered case A 1")
                return {
                    cabin: getters["management/activeCabinKey"],
                    changingCabin: false,
                    route: "bookingCheckout",
                };
            }
            // this cabin is completely done so next cabin
            if (getters["currentCabin/wizard/allCompleted"] &&
                getters["wizard/firstOtherIncompleted"]) {
                // console.log("jumpinfo triggered case B 1")
                return {
                    cabin: getters["wizard/firstOtherIncompleted"],
                    changingCabin: true,
                    route: null,
                };
            }
            if (vm.$route.name === "bookingInsurance") {
                var incompleted = getters["wizard/firstOtherIncompleted"];
                if (incompleted) {
                    // console.log("jumpinfo triggered case D 1")
                    // OK
                    return {
                        cabin: incompleted,
                        changingCabin: true,
                        route: null,
                    };
                }
                else {
                    // than dont change aber go forward !
                    // console.log("jumpinfo triggered case D 2")
                    return {
                        cabin: getters["management/activeCabinKey"],
                        changingCabin: false,
                        route: "bookingCheckout",
                    };
                }
            }
            // default
            // console.log("jumpinfo triggered case default")
            return {
                cabin: getters["management/activeCabinKey"],
                changingCabin: false,
                route: null,
            };
        };
    },
    "wizard/allValid": function (_state, getters) {
        var basket = getters["management/basket"];
        if (!basket.length) {
            return false;
        }
        for (var _i = 0, basket_1 = basket; _i < basket_1.length; _i++) {
            var cabinKey = basket_1[_i];
            if (!getters[cabinKey + "/wizard/allValid"]) {
                return false;
            }
        }
        return true;
    },
    "wizard/allCompleted": function (_state, getters) {
        var basket = getters["management/basket"];
        if (!basket.length) {
            return false;
        }
        for (var _i = 0, basket_2 = basket; _i < basket_2.length; _i++) {
            var cabinKey = basket_2[_i];
            if (!getters[cabinKey + "/wizard/allCompleted"]) {
                return false;
            }
        }
        return true;
    },
    "wizard/firstIncompleted": function (_state, getters) {
        var basket = getters["management/basket"];
        if (!basket.length) {
            return null;
        }
        for (var _i = 0, basket_3 = basket; _i < basket_3.length; _i++) {
            var cabinKey = basket_3[_i];
            if (!getters[cabinKey + "/wizard/allCompleted"]) {
                return cabinKey;
            }
        }
        return null;
    },
    "wizard/firstOtherIncompleted": function (_state, getters) {
        var basket = getters["management/basket"];
        if (!basket.length) {
            return null;
        }
        for (var _i = 0, basket_4 = basket; _i < basket_4.length; _i++) {
            var cabinKey = basket_4[_i];
            if (!getters[cabinKey + "/wizard/allCompleted"] &&
                cabinKey !== getters["management/activeCabinKey"]) {
                return cabinKey;
            }
        }
        return null;
    },
};
var mutations = {};
exports.default = {
    actions: actions,
    getters: getters,
    mutations: mutations,
};
//# sourceMappingURL=wizard.js.map